<template>
  <a 
    href="tel:+37061692311" 
    class="floating-phone-button"
    aria-label="Skambinti dabar"
  >
    <div class="phone-icon-wrapper">
      <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" />
      </svg>
    </div>
    <div class="phone-pulse"></div>
    <div class="phone-ripple"></div>
  </a>
</template>

<script>
export default {
  name: 'FloatingPhoneButton'
}
</script>

<style scoped>
.floating-phone-button {
  position: fixed;
  bottom: 30px;
  left: 30px;
  width: 70px;
  height: 70px;
  background: linear-gradient(135deg, #dc3545, #ff6b6b);
  color: white;
  border-radius: 50%;
  border: 3px solid rgba(255, 255, 255, 0.4);
  text-decoration: none;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 8px 25px rgba(220, 53, 69, 0.5), 
              0 0 0 0 rgba(220, 53, 69, 0.7),
              0 0 0 0 rgba(220, 53, 69, 0.7);
  z-index: 9998;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  font-family: 'Montserrat', sans-serif;
  animation: slideInUp 0.5s ease, pulseRing 2s cubic-bezier(0.4, 0, 0.6, 1) infinite;
  backdrop-filter: blur(10px);
  overflow: visible;
}

.floating-phone-button:hover {
  transform: translateY(-8px) scale(1.1);
  box-shadow: 0 15px 40px rgba(220, 53, 69, 0.6),
              0 0 0 8px rgba(220, 53, 69, 0.1),
              0 0 0 16px rgba(220, 53, 69, 0.05);
  border-color: rgba(255, 255, 255, 0.7);
  background: linear-gradient(135deg, #ff6b6b, #dc3545);
  color: white;
  text-decoration: none;
}

.floating-phone-button:active {
  transform: translateY(-4px) scale(1.05);
  box-shadow: 0 10px 30px rgba(220, 53, 69, 0.5);
}

.phone-icon-wrapper {
  width: 100%;
  height: 100%;
  background: transparent;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  z-index: 2;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

.floating-phone-button:hover .phone-icon-wrapper {
  transform: rotate(15deg) scale(1.1);
}

.phone-icon-wrapper svg {
  width: 32px;
  height: 32px;
  color: white;
  filter: drop-shadow(0 2px 4px rgba(0, 0, 0, 0.2));
  transition: all 0.3s ease;
}

.floating-phone-button:hover .phone-icon-wrapper svg {
  filter: drop-shadow(0 4px 8px rgba(0, 0, 0, 0.3));
}

.phone-pulse {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 100%;
  height: 100%;
  border-radius: 50%;
  background: linear-gradient(135deg, #dc3545, #ff6b6b);
  animation: pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite;
  z-index: -1;
  opacity: 0.6;
}

.phone-ripple {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 100%;
  height: 100%;
  border-radius: 50%;
  border: 2px solid rgba(255, 255, 255, 0.3);
  animation: ripple 2s cubic-bezier(0.4, 0, 0.6, 1) infinite;
  z-index: -2;
}

@keyframes slideInUp {
  from {
    transform: translateY(100px);
    opacity: 0;
  }
  to {
    transform: translateY(0);
    opacity: 1;
  }
}

@keyframes pulse {
  0% {
    transform: translate(-50%, -50%) scale(1);
    opacity: 0.6;
  }
  50% {
    transform: translate(-50%, -50%) scale(1.2);
    opacity: 0.3;
  }
  100% {
    transform: translate(-50%, -50%) scale(1.4);
    opacity: 0;
  }
}

@keyframes pulseRing {
  0% {
    box-shadow: 0 8px 25px rgba(220, 53, 69, 0.5), 
                0 0 0 0 rgba(220, 53, 69, 0.7),
                0 0 0 0 rgba(220, 53, 69, 0.7);
  }
  50% {
    box-shadow: 0 8px 25px rgba(220, 53, 69, 0.5), 
                0 0 0 8px rgba(220, 53, 69, 0.3),
                0 0 0 16px rgba(220, 53, 69, 0.1);
  }
  100% {
    box-shadow: 0 8px 25px rgba(220, 53, 69, 0.5), 
                0 0 0 0 rgba(220, 53, 69, 0),
                0 0 0 0 rgba(220, 53, 69, 0);
  }
}

@keyframes ripple {
  0% {
    transform: translate(-50%, -50%) scale(1);
    opacity: 0.6;
  }
  100% {
    transform: translate(-50%, -50%) scale(1.8);
    opacity: 0;
  }
}

@media (max-width: 768px) {
  .floating-phone-button {
    bottom: 20px;
    left: 20px;
    width: 60px;
    height: 60px;
    border-width: 2px;
  }
  
  .phone-icon-wrapper svg {
    width: 28px;
    height: 28px;
  }
}
</style>

